import { PageHero } from '@/components/ui/PageHero'
import { courseWorkshop } from '@/assets/siteMedia'

export const BlogHero = () => (
  <PageHero
    image={courseWorkshop}
    imageAlt="Kandake teaching a herbal workshop to a seated group"
    highlights={['Herbal medicine', "Women's health", 'Seasonal wellbeing', 'Nature connection']}
    title="Herbal wisdom,"
    accent="shared openly."
    description={
      <p>Health insights, herbal wisdom, and clinical education from Kandake Makonnen.</p>
    }
  />
)
